var default_1 = /** @class */ (function () {
    function default_1() {
        this.Drawer();
    }
    default_1.prototype.Drawer = function () {
        var toggle = function (e) {
            var drawerBtn = document.querySelector('#btn-drawer');
            var avatarBtn = document.querySelector('#avatar-profile');
            var htmlBody = document.querySelector('body');
            drawerBtn.classList.toggle('open');
            if (avatarBtn) {
                avatarBtn.classList.toggle('open');
            }
            htmlBody.classList.toggle('lock');
            var drawerMenu = document.querySelectorAll('#menu-drawer > *');
            drawerMenu.forEach(function (elm) { elm.classList.toggle('open'); });
        };
        var drawerButton = document.querySelector('#btn-drawer');
        var avatarBtn = document.querySelector('#avatar-profile');
        var drawerBg = document.querySelector('#menu-drawer > .bg');
        drawerButton.onclick = toggle;
        if (avatarBtn) {
            avatarBtn.onclick = toggle;
        }
        drawerBg.onclick = toggle;
    };
    return default_1;
}());
export default default_1;
